import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";

const VFCCollaboration = () => {
  const [formState, setFormState] = useState({
    rangeName: "",
    vfc1Name: "",
    vfc2Name: "",
    date: "",
    reason: "",
    note: "",
    picture: null,
  });
  const [range, setRange] = useState([]);
  const [vfcData, setVfcData] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedVfcData, setSelectedVfcData] = useState([]);
  const [selectedVfc1, setSelectedVfc1] = useState("");
  const [selectedVfc2, setSelectedVfc2] = useState("");
  const { access } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchRange = async () => {
      try {
        const response = await axios.get(`${Api}/api/ranges`);
        const data = response.data;

        if (Array.isArray(data)) {
          const filteredRangedata = data.filter((range) =>
            access.rangeId.includes(range._id)
          );
          setRange(filteredRangedata);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };

    fetchRange();
  }, [access]);

  const handleRangeChange = (e) => {
    setSelectedRange(e.target.value);
  };

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const response = await axios.get(`${Api}/api/vfcs`);
        const data = response.data.vfcs;

        if (Array.isArray(data)) {
          const filteredVfcData = data.filter((vfc) =>
            access.vfcId.includes(vfc._id)
          );
          setVfcData(filteredVfcData);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };
    fetchVfc();
  }, [access]);

  useEffect(() => {
    if (selectedRange) {
      const filteredVfcData = vfcData.filter(
        (vfc) => vfc.rangeId._id === selectedRange
      );
      setSelectedVfcData(filteredVfcData);
    } else {
      setSelectedVfcData([]);
    }
  }, [selectedRange, vfcData]);

  const handleVfcChange = (e, vfcType) => {
    const selectedValue = e.target.value;
    if (vfcType === "vfc1") {
      setSelectedVfc1(selectedValue);
      setFormState((prevState) => ({
        ...prevState,
        vfc1Name: selectedValue,
      }));
    } else if (vfcType === "vfc2") {
      setSelectedVfc2(selectedValue);
      setFormState((prevState) => ({
        ...prevState,
        vfc2Name: selectedValue,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormState((prevState) => ({
      ...prevState,
      picture: e.target.files[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log(formState);
  };

  return (
    <Container>
      <Preloader loading={loading} />
      <h4>VFC Collaboration Form</h4>

      <Row className="justify-content-md-center mt-5">
        <Col xs={12} md={8}>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col>
                <div className="input-container">
                  <Form.Group controlId="formRangeName" className="mb-3">
                    <Form.Label>Range</Form.Label>
                    <Form.Control
                      as="select"
                      name="rangeName"
                      value={selectedRange}
                      onChange={handleRangeChange}
                      required
                    >
                      <option value="">Select Range</option>
                      {range.map((range) => (
                        <option key={range._id} value={range._id}>
                          {range.rangeName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </Col>
              <Col>
                <div className="input-container">
                  <Form.Group controlId="formVfc1Name" className="mb-3">
                    <Form.Label>VFC 1 Name</Form.Label>
                    <Form.Control
                      as="select"
                      name="vfc1Name"
                      value={selectedVfc1}
                      onChange={(e) => handleVfcChange(e, "vfc1")}
                      required
                    >
                      <option value="">Select VFC 1</option>
                      {selectedVfcData.map((vfc) => (
                        <option key={vfc._id} value={vfc._id}>
                          {vfc.vfcName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </Col>
              <Col>
                <div className="input-container">
                  <Form.Group controlId="formVfc2Name" className="mb-3">
                    <Form.Label>VFC 2 Name</Form.Label>
                    <Form.Control
                      as="select"
                      name="vfc2Name"
                      value={selectedVfc2}
                      onChange={(e) => handleVfcChange(e, "vfc2")}
                      required
                    >
                      <option value="">Select VFC 2</option>
                      {selectedVfcData.map((vfc) => (
                        <option key={vfc._id} value={vfc._id}>
                          {vfc.vfcName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </Col>
            </Row>
            <div className="input-container">
              <Form.Group controlId="formDate" className="mb-3">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={formState.date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>

            <div className="input-container">
              <Form.Group controlId="formReason" className="mb-3">
                <Form.Label>Reason</Form.Label>
                <Form.Control
                  as="select"
                  name="reason"
                  value={formState.reason}
                  onChange={handleChange}
                  required
                >
                  <option>Select</option>
                  <option>Meeting</option>
                  <option>Work Opportunity</option>
                  <option>Awareness Programs</option>
                  <option>Govt Schemes Meeting</option>
                </Form.Control>
              </Form.Group>
            </div>

            <div className="input-container">
              <Form.Group controlId="formNote" className="mb-3">
                <Form.Label>Note</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="note"
                  value={formState.note}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>

            <div className="input-container">
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Upload Picture</Form.Label>
                <Form.Control
                  type="file"
                  name="picture"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </div>

            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default VFCCollaboration;
